import { Component, OnInit, OnDestroy, Output, EventEmitter, Input} from '@angular/core';
import { ShopMaxPerDay } from '../../../shared/models/slot-management.model';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { SalesAvailabilityState } from '../../../store/sales-availability/sales-availability.reducer';
import * as fromActions from '../../../store/sales-availability/sales-availability.actions';
import * as fromSelector from '../../../store/sales-availability/sales-availability.selectors';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { titleCase, unsubscribeSubscriptions } from '../../../shared/services/util.service';
import _ from 'lodash'
import { SubscriptionList } from 'src/app/modules/shared/models/asp.types';

@Component({
  selector: 'app-sales-shop-max',
  templateUrl: './sales-shop-max.component.html',
  styleUrls: ['./sales-shop-max.component.scss']
})
export class SalesShopMaxComponent implements OnInit, OnDestroy {

  totalCapacity: number = 0;
  subscriptions: SubscriptionList = {};
  shopMaxTotal$: Observable<ShopMaxPerDay[]>;
  salesShopMaxForm: UntypedFormGroup;
  @Input() saveClicked:boolean
  @Input() cancleClicked:boolean
  @Output() formEdited:EventEmitter<boolean> = new EventEmitter();
  @Output() cancleClick:EventEmitter<boolean> = new EventEmitter();
  @Output() saveClick:EventEmitter<boolean>=new EventEmitter();
  isFormEdited:boolean=false;
  lastValue:any

  constructor(private salesAvailabilityState: Store<SalesAvailabilityState>,
    private readonly formBuilder: UntypedFormBuilder,
    private translate: TranslateService) {
    this.salesShopMaxForm = this.formBuilder.group({
      shopMaxDetails: this.formBuilder.array([])
    })
    this.setupStore();
    this.initializeValues();
  }

  ngOnInit() {
    this.subscriptions.formChanges = this.salesShopMaxForm.valueChanges.subscribe(value => {
      this.calculateTotals();
      this.formEdited.emit(this.salesShopMaxForm.dirty)
  
    } )
  }

  ngOnChanges()
  {
    if(this.saveClicked && this.salesShopMaxForm.dirty )
    {
      this.onSave(); 
    }
    if(this.cancleClicked && this.salesShopMaxForm.dirty)
    {
      this.onCancel();
    }  
  }
  
  calculateTotals() {
    this.totalCapacity = 0;
    this.shopMaxDetails.value.forEach(a => this.totalCapacity += a.slotCapacity);
  }

  get shopMaxDetails() {
    return this.salesShopMaxForm.controls.shopMaxDetails as UntypedFormArray;
  }

  setShopMaxDetails(formArray: UntypedFormArray, data: ShopMaxPerDay[]) {
    if (data && data.length) {
      formArray.clear();
      data.forEach((total: ShopMaxPerDay) => {
        formArray.push(new UntypedFormGroup({
          dayOfWeek: new UntypedFormControl(total.dayOfWeek),
          hoursOfOperation: new UntypedFormControl(total.hoursOfOperation),
          slotCapacity: new UntypedFormControl(total.slotCapacity)
        }));
      });
    }
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
  }

  onSave() {
    this.salesAvailabilityState.dispatch(new fromActions.UpdateShopMaxTotal({ shopMaxTotal: this.shopMaxDetails.value }))
    this.saveClick.emit(false)
    this.formEdited.emit(false)
    this.salesShopMaxForm.markAsPristine()
    }

  onCancel() {
    this.subscriptions.shopMaxTotal = this.shopMaxTotal$.pipe(take(1)).subscribe(total => {
      this.setShopMaxDetails(this.shopMaxDetails, total);
    });
    this.cancleClick.emit(false)  
  }

  setupStore(){
    this.salesAvailabilityState.dispatch(new fromActions.LoadShopMaxTotal());
    this.shopMaxTotal$ = this.salesAvailabilityState.select(fromSelector.selectShopMaxTotal);
  }

  initializeValues(){
    this.subscriptions.shopMax = 
      this.shopMaxTotal$.subscribe(total => {
        this.setShopMaxDetails(this.shopMaxDetails, total);
        this.calculateTotals();
      });
  }
  
  getWeekTranslation(value){
   return value ? this.translate.instant(`common.${titleCase(value)}`) : value;
  }
}
